/*
    Device.js -
 */

import {Rest} from '@/paks/vu-app'

export default new Rest(
    'Device',
    {
        claim: {method: 'POST', uri: '/:controller/claim'},
    },
    {cache: false}
)
